'use strict';
var $ = require('jquery');
var ViewportTracker = require('../lib/ViewportTracker.js');
var AnimationEasing = require('../lib/AnimationEasing.js');
//var MobileLogger = require('./MobileLogger.js');

// NOTE: IE11 and lower have issues with jQuery.slideDown(), need elements to
// have zoom: 1; to work right. Because reasons.

function init() {
	(function detectAndroidBrowser(html, userAgent) {
		if (/android\s(\d)/ig.test(userAgent) && !/(chrome|iemobile)/ig.test(userAgent)) {
			var versionOs = /[\d\.]+/.exec(/android\s[\d\.]*/ig.exec(userAgent));
			var versionBrowser = /[\d\.]+/.exec(/version\/.*\s/ig.exec(userAgent));
			html.addClass('android-os-' + versionOs).addClass('android-browser-' + versionBrowser);
		}
	})($('html'), navigator.userAgent);

	var animationUnsupported = $('html').hasClass('android-browser-4.0');

	//* for testing */MobileLogger.init();
	//* for testing */MobileLogger.log($('html').attr('class'));
	var config = {
		menu 			: '#menu',
		menuActive 		: false,
		menuTarget 		: '.menu__inner',
		nodeTarget 		: '.childWrap',
		nodeTrigger 	: '.node--hasChild > a',
		backTarget 		: '.childWrap__back',
		headTarget 		: '.childWrap__heading',
		triggers 		: '#menuTrigger--open, #menuTrigger--close, #menuOverlay',
		triggerEvent 	: 'click',
		isCollapsable 	: true,
		isSlidable 		: false
	};
	var configCollapsable = {
		duration: 400 /* slideToggle duration */
	};
	var styleClass = {
		setup 			: 'hasMenuSetup',
		settingUp 		: 'hasMenuSettingUp',
		menuOpen 		: 'hasMenuOpen',
		nodeOpen 		: 'isOpen',
		nodeOpenMenu 	: 'hasNodeOpen',
		backWrap 		: 'childWrap__back',
		headWrap 		: 'childWrap__heading'
	}
	var $menu = $(config.menu);
	var $stateElem = $menu;
	var $nodeTarget = $menu.find(config.nodeTarget);
	var $menuTarget = $menu.find(config.menuTarget);

	/*
	 * Creates "Main Menu" button for child panel
	 * */
	function createBackButton() {
		if ( $(config.backTarget).length != 0 ) {
			return;
		}
		var $backButton = $('<div class="' + styleClass.backWrap + ' menu__ribbon"><button>Main Menu</button></div>');
		$nodeTarget.prepend($backButton.clone());
		$nodeTarget.on('click.back', 'button', function( ){
			$(this).parents(config.nodeTarget).siblings('a').trigger('click');
		});
	}
	function createHeading() {
		if ( $(config.headTarget).length != 0 ) {
			return;
		}
		$nodeTarget.each(function(){
			var text = $(this).siblings('a').text();
			$(this).prepend( '<div class="' + styleClass.headWrap + '">'+text+'</div>' );
		});
	}

	function toggleMenu(event) {
		event.preventDefault();
		$stateElem.toggleClass(styleClass.menuOpen);
	}
	function toggleNode(event) {
		event.preventDefault();
		var $eventTarget = $(event.currentTarget);
		$eventTarget.closest('.node--hasChild').toggleClass(styleClass.nodeOpen);
		$menuTarget.toggleClass(styleClass.nodeOpenMenu);
		if (config.isCollapsable) {
			$eventTarget.next().slideToggle((animationUnsupported ? 0 : configCollapsable.duration), AnimationEasing.easeOutExpo);
		}
		//* for testing */MobileLogger.log(event.target.tagName + ' + .' + $eventTarget.next().get(0).StyleClass);
	}
	function setupChildren() {
		if (config.isSlidable) {
			createHeading();
			createBackButton();
		}
		/* $stateElem.addClass(styleClass.settingUp);
		$stateElem.addClass(styleClass.setup);
		var timeout = window.setTimeout(function() {
			$stateElem.removeClass(styleClass.settingUp);
		}, 10); */
		$nodeTarget.filter('.isActive').parents('li').addClass(styleClass.nodeOpen);
		if (config.isCollapsable) {
			$nodeTarget.stop().slideUp().filter('.isActive').slideDown();
		}
		$menuTarget.find('.node--hasChild.node--isActive').parents(config.menuTarget).addClass(styleClass.nodeOpenMenu);
		//* for testing */MobileLogger.log($nodeTarget.get(0).tagName);
	}
	function teardownChildren() {
		/* $stateElem.removeClass(styleClass.setup); */
		$menuTarget.removeClass(styleClass.nodeOpenMenu);
		$nodeTarget.parents('li').removeClass(styleClass.nodeOpen);
		$nodeTarget.stop().slideDown().attr('style', '');
	}
	function attachEvents() {
		if (config.menuActive === true) {
			return;
		}
		$(config.triggers).on(config.triggerEvent, toggleMenu);
		setupChildren();
		$menu.on('click.mobileMenu', config.nodeTrigger, toggleNode);
	}
	function detachEvents() {
		if (config.menuActive === false) {
			return;
		}
		$(config.triggers).off(config.triggerEvent, toggleMenu);
		teardownChildren();
		$menu.off('click.mobileMenu');
	}
	function onViewportState() {
		var state = ViewportTracker.getState();
		$stateElem.removeClass(styleClass.menuOpen);
		if (state == 'mobile') {
			attachEvents();
			config.menuActive = true;
		} else {
			detachEvents();
			config.menuActive = false;
		}
	}

	// Calling this here appears redundant as it already runs. Was breaking <=IE11
	// onViewportState();

	$(window).on('ViewportTracker:state', onViewportState);
}

module.exports = {
	init : init
};
